import { render, staticRenderFns } from "./cover3.vue?vue&type=template&id=ba16e114&scoped=true&"
import script from "./cover3.vue?vue&type=script&lang=js&"
export * from "./cover3.vue?vue&type=script&lang=js&"
import style0 from "./cover3.vue?vue&type=style&index=0&id=ba16e114&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba16e114",
  null
  
)

export default component.exports